import { render } from "./Toggle.vue?vue&type=template&id=58c22dda&scoped=true&ts=true"
import script from "./Toggle.vue?vue&type=script&lang=ts"
export * from "./Toggle.vue?vue&type=script&lang=ts"

import "./Toggle.vue?vue&type=style&index=0&id=58c22dda&lang=scss&scoped=true"
import "./Toggle.vue?vue&type=style&index=1&id=58c22dda&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c22dda"]])

export default __exports__